import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import createStation from '../helper/create_station';
import {isEqual} from '../../../lib/utilities';


const loadingLabel = 'calculating...';

class ActiveStationStoreClass extends ReduceStore {
    getInitialState() {
        return {
            initialLoading: false,
            initialFetchingFailed: false,
            activeStation: null,
            wheelAlignment: {
                wheels2: [],
                wheels4: []
            },
        };
    }
    reduce(state, {source, action}) {
        const { type } = action;

        if (source === 'ACTIVE_STATION_ACTION') {
            let wheelAlignmentList;
            let listPosition;

            switch (type) {
                case 'SET_ACTIVE_STATION':
                    if (!isEqual(state.activeStation, action.payload)) {
                        state.activeStation = createStation(action.payload);
                        this.__emitChange();
                    }
                    break;

                case 'UNSET_ACTIVE_STATION':
                    state.activeStation = null;
                    this.__emitChange();
                    break;

                case 'FETCH_INITIAL_STATION':
                    if (state.initialLoading === false) {
                        state.initialLoading = true;
                        Object.assign(state.activeStation, {
                            totalExpenses: loadingLabel,
                            totalPrice: loadingLabel,
                            totalShipping: loadingLabel,
                            totalCart: loadingLabel,
                            wheelAlignment: {
                                wheels_2: loadingLabel,
                                wheels_4: loadingLabel
                            }
                        });
                        state.initialFetchingFailed = false;
                        this.__emitChange();
                    }
                    break;

                case 'INITIAL_STATION_FETCHED':
                    if (!action.payload.totalExpenses) {
                        state.activeStation = null;
                    } else {
                        let payload = action.payload;
                        let { expenses } = payload;
                        Object.assign(state.activeStation, {
                            totalExpenses: payload.totalExpenses,
                            shippingTime: payload.shippingTime,
                            matesRatesTotalRaw: payload.totalMatesRates,
                            totalPrice: payload.totalFittingCost,
                            totalShipping: payload.totalShipping,
                            totalCart: payload.total,
                            wheelAlignment: {
                                wheels_2: payload.wheelAlignment ?
                                    payload.wheelAlignment.wheels_2 :
                                    TYROOLA.initialFluxStates.initialStation.wheelAlignment.wheels_2,
                                wheels_2_totals: payload.total,
                                wheels_4: payload.wheelAlignment ?
                                    payload.wheelAlignment.wheels_4 :
                                    TYROOLA.initialFluxStates.initialStation.wheelAlignment.wheels_4,
                                wheels_4_totals: payload.total,
                            },
                            expenses: {
                                shipping: expenses.shipping,
                                fitting: expenses.fitting,
                                wheelAlignment: {
                                    wheels_2: expenses.wheelAlignment ?
                                        expenses.wheelAlignment.wheels_2 :
                                        TYROOLA.initialFluxStates.initialStation.expenses.wheelAlignment.wheels_2,
                                    wheels_4: expenses.wheelAlignment ?
                                        expenses.wheelAlignment.wheels_4 :
                                        TYROOLA.initialFluxStates.initialStation.expenses.wheelAlignment.wheels_4,
                                },
                            },
                            isMarketplaceSeller: payload.isMarketplaceSeller ?
                                payload.isMarketplaceSeller :
                                TYROOLA.initialFluxStates.initialStation.isMarketplaceSeller,
                            mpsDoesSameDayFitting: payload.mpsDoesSameDayFitting ?
                                payload.mpsDoesSameDayFitting :
                                TYROOLA.initialFluxStates.initialStation.mpsDoesSameDayFitting,
                            mpsDoesSameDayFittingCutoff: payload.mpsDoesSameDayFittingCutoff ?
                                payload.mpsDoesSameDayFittingCutoff :
                                TYROOLA.initialFluxStates.initialStation.mpsDoesSameDayFittingCutoff,
                        });
                    }

                    state.initialLoading = false;
                    this.__emitChange();
                    break;

                case 'FETCHING_INITIAL_STATION_FAILED':
                    state.activeStation = null;
                    state.initialLoading = false;
                    state.initialFetchingFailed = true;
                    this.__emitChange();
                    break;

                case 'SET_WHEEL_ALIGNMENT':
                    state = this.setWheelAlignment(
                        state,
                        action.payload.wheelAmount,
                        action.payload.stationId
                    );
					this.__emitChange();

                    break;

                case 'UNSET_WHEEL_ALIGNMENT':
                    wheelAlignmentList = state.wheelAlignment['wheels' + action.payload.wheelAmount];
                    listPosition = wheelAlignmentList.indexOf(action.payload.stationId);

                    if (listPosition > -1) {
                        wheelAlignmentList.splice(listPosition, 1);
                        this.__emitChange();
                    }

                    break;
            }
        }
        else if (source === 'STATION_LIST_ACTION') {
            if (type === 'STATIONS_FETCHED') {
                const stations = action.payload.stations;
                const activeStation = state.activeStation ? stations.find(station => station.id === state.activeStation.id) : undefined;
                if (activeStation && !isEqual(activeStation, state.activeStation)) {
                    state.activeStation = createStation(activeStation);
                    this.__emitChange();
                }

                const stationsWithBillableWheelALignment = stations.filter(
                    ({ wheelAlignment }) => wheelAlignment && wheelAlignment.billable
                );

                // always select wheel alignment for 4 tyres
                stationsWithBillableWheelALignment.forEach(
                    station => this.setWheelAlignment(state, 4, station.id)
                );
                this.__emitChange();
            }
        }

        return state;
    }

    setWheelAlignment(state, wheelAmount, stationId) {
        let wheelsPropertyName = 'wheels' + wheelAmount;
        const wheelAlignmentList = state.wheelAlignment[wheelsPropertyName];
        const listPosition = wheelAlignmentList.indexOf(stationId);

        if (listPosition === -1) {
            wheelAlignmentList.push(stationId);

            // remove from other list
            const oppositeList = state.wheelAlignment['wheels' + (wheelsPropertyName === 'wheels2' ? '4' : '2')];
            const oppositeIndex = oppositeList.indexOf(stationId);

            if (oppositeIndex !== -1) {
                oppositeList.splice(oppositeIndex, 1);
            }
        }

        return state;
    }
}

const ActiveStationStore = new ActiveStationStoreClass(Dispatcher);
export default ActiveStationStore;
